import CompanyFormModal from 'components/company-form-modal/company-form-modal';
import SelectCompanyField from 'components/select-company-field/select-company-field';
import { useFormikContext } from 'formik';
import React, { FunctionComponent, useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Button, Form, Icon } from 'semantic-ui-react';

type CompanyModalState = {
  open: boolean;
  id?: number;
};

type CompanyFieldProps = {
  billingEmailSuggestions: string[];
  name: string;
  value: number | null;
  label?: string;
  helpText?: string;
  onCompanyUpdated?: () => void;
};

const CompanyField: FunctionComponent<CompanyFieldProps> = ({
  billingEmailSuggestions,
  value,
  label,
  helpText,
  name,
  onCompanyUpdated: onUpdate,
}) => {
  const { setFieldValue } = useFormikContext();
  const [searchParams, setSearchParams] = useSearchParams();

  const [companyModal, setCompanyModal] = useState<CompanyModalState>({
    open: false,
  });

  const [shouldRefetch, setShouldRefetch] = useState<boolean>(false);

  // Auto-open modal when URL has ?action=update-company
  useEffect(() => {
    if (searchParams.get('action') === 'update-company' && value) {
      setCompanyModal({ open: true, id: value });
      setSearchParams((prev) => {
        prev.delete('action');
        return prev;
      });
    }
  }, [searchParams, value, setSearchParams]);

  return (
    <>
      <Form.Group widths="equal">
        <SelectCompanyField
          label={label}
          helpText={helpText}
          name={name}
          selection
          search
          clearable
          shouldRefetch={shouldRefetch}
          selectOnBlur={false}
          onRefetch={(): void => {
            setShouldRefetch(false);
          }}
        />
        {value ? (
          <Button
            icon
            primary
            style={{ minWidth: '45px', marginTop: '45px' }}
            type="button"
            onClick={(): void => {
              setCompanyModal({ open: true, id: value });
            }}
          >
            <Icon name="pencil alternate" />
          </Button>
        ) : null}
        <Button
          icon
          positive
          style={{ minWidth: '45px', marginTop: '45px' }}
          type="button"
          onClick={(): void => {
            setCompanyModal({ open: true });
          }}
        >
          <Icon name="plus" />
        </Button>
      </Form.Group>
      <CompanyFormModal
        billingEmailSuggestions={billingEmailSuggestions}
        open={companyModal.open}
        companyId={companyModal.id}
        onClose={(): void => {
          setCompanyModal({ open: false });
        }}
        onCompanyCreated={(companyId): void => {
          setFieldValue(name, companyId);
          setShouldRefetch(true);
          setCompanyModal({ open: false });
        }}
        onCompanyUpdated={onUpdate}
      />
    </>
  );
};

export default CompanyField;
